<template>
    <v-container grid-list-sm text-xs-left>
        <v-toolbar flat color="white">
            <v-toolbar-title>Contacts</v-toolbar-title>
            <v-divider
                    class="mx-2"
                    inset
                    vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-flex xs12 md4 class="pl-3">
                <v-text-field
                        class="pt-1"
                        v-model="search"
                        :append-icon="search?'close':'search'"
                        @click:append="search = ''"
                        label="Search"
                        single-line
                        hide-details
                        @keydown.native.escape="search=''">
                </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="downloadContacts">Download</v-btn>
        </v-toolbar>
        <v-data-table
                :headers="headers"
                :search="search"
                :items="contacts"
                :rows-per-page-items='[5, 10, 25, 50, 100]'
                class="elevation-1"
        >
            <template v-slot:items="props">
                <td class="text-xs-center">{{ props.item.name }}</td>
                <td class="text-xs-center">{{ props.item.surname }}</td>
                <td class="text-xs-center">{{ props.item.email }}</td>
                <td class="text-xs-center">{{ props.item.company }}</td>
            </template>
        </v-data-table>

    </v-container>
</template>

<script>
    import UrlsService from "@/helpers/UrlsService";
    import TimeService from "@/helpers/TimeService";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import ExcelJS from 'exceljs';
    import FileSaver from 'file-saver';



    export default {
        name: "GhostContactsTable",
        components: {},
        data() {
            return {
                search: '',
                headers: [
                    {text: 'Name', align: "center", value: 'name' },
                    {text: 'Surname', align: "center", value: 'surname' },
                    {text: 'Email', align: "center", value: 'email' },
                    {text: 'Company', align: "center", value: 'company' },
                ],
                contacts: [],
            }
        },
        created(){
            this.getContacts();
        },

        methods: {
            downloadContacts(){
                let workbook = new ExcelJS.Workbook();
                let sheet = workbook.addWorksheet('Contacts');
                let keys =  ["name","surname","email","company"]
                let columns = [];
                columns.push({header: "Name", key: "name", width: 25})
                columns.push({header: "Surname", key: "surname", width: 25})
                columns.push({header: "Email", key: "email", width: 25})
                columns.push({header: "Company", key: "company", width: 25})
                sheet.columns = columns;
                for (let j = 0; j<this.contacts.length; j++){
                    sheet.addRow(this.contacts[j]);
                }
                sheet.getRow(1).font = {size: 12, bold: true, color: {argb: 'FFFFFFFF'}};
                sheet.getRow(1).eachCell(function(cell, colNumber) {
                        cell.fill = {
                            type: 'pattern',
                            pattern:'solid',
                            fgColor:{argb:'FF4169E1'},
                            bgColor:{argb:'FF4169E1'}
                        };
                    }
                )

                let borderStyles = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                };
                sheet.eachRow({ includeEmpty: true },function(row, rowNumber) {
                    row.eachCell(function(cell, colNumber) {
                        cell.border = borderStyles;
                        cell.alignment = { wrapText: true };
                    });
                });
                workbook.xlsx.writeBuffer()
                    .then(buffer => FileSaver.saveAs(new Blob([buffer]), `Contacts.xlsx`))
                    .catch(err => console.log('Error writing excel export', err))


            },

            getContacts(){
                let requestUrl = {
                    url: UrlsService.contactsGhost,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        text: "LIST",
                        contactRequest: {
                        },
                    }

                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData
                    },
                };
                let messages = {
                    title: "Get contacts",
                    loading: "Get contacts",
                    error: "Server Error",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };

                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        let response = responseSuccess;
                        this.contacts = response.response.contacts;

                    });


            }
        },
    };
</script>

<style lang="scss">
    tbody tr:nth-of-type(odd) {
        background-color: rgba(0, 0, 0, .05);
    }
</style>

